if($('.type-detail').length){
    var textFriends = 'Alternativa'
    if($('table.detail-parameters tbody tr th').text().trim().includes(textFriends)){
                $('table.detail-parameters tbody tr:contains('+textFriends+')').closest('tr').hide()
                var apiUrl = "https://friends.shopcode.cz/new/api-products.php";
                var section = "batteryImportCZ";
                var codes = [];
                $('table.detail-parameters tbody tr').each(function () {
                    var headerText = $(this).find('th span.row-header-label').text().trim();
                    var friendName = $(this).find('td').text().trim();
                    if (headerText.includes(textFriends)) {
                        $(this).closest('tr').hide()
                        codes.push(friendName);
                    }
    });
       if (codes.length === 0) {
            console.warn("Žádné hodnoty " + textFriends + " nebyly nalezeny.");
        } else {
            $.ajax({
                url: apiUrl,
                type: "GET",
                data: {
                    section: section,
                    codes: getShoptetDataLayer('product').codes[0].code
                },
                dataType: "json",
                success: function(response) {
                    console.log("API odpověď:", response);
                    if (!response || !response.result || !response.result.length) {
                        console.warn("Žádné výsledky v odpovědi.");
                        return;
                    }
                    $('.p-info-wrapper').append('<div class="alternativeProducts"></div>')
                    const alternatives = response.result[0].alternatives || [];
                    alternatives.sort((a, b) => a.NAME.localeCompare(b.NAME, 'cs', { sensitivity: 'base' }));
                    const $list = $('.alternativeProducts');
                    $list.empty();
                    alternatives.forEach(item => {
                         if (item.is_main) return;
                        const price = item.ACTIONPRICE > 0 ? item.ACTIONPRICE : item.PRICE;
                        $list.append(`
                            <div class="altItem" data-primary="${item.is_main}">
                                <a href="${item.URL}"></a>
                                <div class="image"><img src="${item.IMAGE}" alt="${item.NAME}"></div>
                                <span class="name">${item.NAME}</span>
                                <span class="price">${Number(price).ShoptetFormatAsCurrency()}</span>
                            </div>
                        `);
                    });
                },
                error: function(xhr, status, error) {
                    console.error("Chyba při načítání:", error);
                }
            });
        }
    }



    if ($('.p-detail-inner').length && window.dataLayer && window.dataLayer[0]?.shoptet) {

        var shoptetData = window.dataLayer[0].shoptet;

        var stocksId = (shoptetData.stocks || []).sort(function (a, b) {
            return a.id - b.id;
        });

        var stocksValue = [];

        if (
            shoptetData.product &&
            shoptetData.product.codes &&
            shoptetData.product.codes.length &&
            shoptetData.product.codes[0].stocks
        ) {
            stocksValue = shoptetData.product.codes[0].stocks.sort(function (a, b) {
                return a.id - b.id;
            });
        }

        var resultObj = {};
        var totalQuantity = 0;

        $.each(stocksId, function (key, value) {

            var qty = 0;

            if (stocksValue[key] && stocksValue[key].quantity) {
                qty = parseInt(stocksValue[key].quantity) || 0;
            }

            totalQuantity += qty;

            if (value.title === "Prodejna a centrální sklad JESENICE, ul. K Rybníku") {
                resultObj[3] = '<tr><td class="c-stocks__name">JESENICE:</td><td class="c-stocks__value"><span class="nowrap">' + qty + ' ks</span></td></tr>';
            } else if (value.title === "Prodejna PRAHA, ul. Brožíkova") {
                resultObj[0] = '<tr><td class="c-stocks__name">PRAHA:</td><td class="c-stocks__value"><span class="nowrap">' + qty + ' ks</span></td></tr>';
            } else if (value.title === "Prodejna BRNO, ul. Pražákova") {
                resultObj[1] = '<tr><td class="c-stocks__name">BRNO:</td><td class="c-stocks__value"><span class="nowrap">' + qty + ' ks</span></td></tr>';
            } else if (value.title === "Prodejna NEHVIZDY, ul. Pražská") {
                resultObj[2] = '<tr><td class="c-stocks__name">NEHVIZDY:</td><td class="c-stocks__value"><span class="nowrap">' + qty + ' ks</span></td></tr>';
            } else if (value.title === "Prodejna ÚSTÍ NAD LABEM, ul. Žižkova") {
                resultObj[4] = '<tr><td class="c-stocks__name">ÚSTÍ NAD LABEM:</td><td class="c-stocks__value"><span class="nowrap">' + qty + ' ks</span></td></tr>';
            }
        });
        if (!$('.c-stocks').length) {
            $('.availability-value').prepend('<table class="c-stocks" />');
        }
        if (totalQuantity === 0) {
            $('.availability-label, .availability-amount').show();
            $('.c-stocks').hide();
        } else {
            $('.availability-label, .availability-amount').hide();
        }

        

        $('.c-stocks').empty();

        $.each(resultObj, function (key, value) {
            $('.c-stocks').append(value);
        });
    }
}